(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ve-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.querySelector('[data-ve-wishlist]');
      if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const strings = dialog.dataset;
      const key = 've-wishlist-v1';
      const legacyKey = 've-new-in-saved-products';
      const body = dialog.querySelector('[data-ve-wishlist-content]');
      const itemTemplate = document.getElementById('VEWishlistItem');
      const emptyTemplate = document.getElementById('VEWishlistEmpty');
      const toast = document.querySelector('[data-ve-wishlist-toast]');
      const cache = new Map();
      let generation = 0;
      let toastTimer;
      let opener;
      let scheduled = false;
      const validHandle = value => typeof value === 'string' && value.length > 0 && value.length <= 255 && !/[\s/?#]/.test(value);
      const safeUrl = (value, image = false) => {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.origin);
          if (!['https:', 'http:'].includes(url.protocol)) return '';
          if (url.origin !== window.location.origin && (!image || !/(^|\.)shopify(?:cdn)?\.(com|net)$/.test(url.hostname))) return '';
          return url.href;
        } catch { return ''; }
      };
      const productUrl = handle => strings.root + 'products/' + encodeURIComponent(handle);
      const clean = items => {
        if (!Array.isArray(items)) return [];
        const seen = new Set();
        return items.flatMap(item => {
          const value = typeof item === 'string' ? {handle: item} : item;
          if (!value || !validHandle(value.handle) || seen.has(value.handle)) return [];
          seen.add(value.handle);
          return [{handle: value.handle, title: typeof value.title === 'string' ? value.title : value.handle.replaceAll('-', ' '), url: safeUrl(value.url) || productUrl(value.handle), image: safeUrl(value.image, true)}];
        });
      };
      const read = () => {
        try { return clean(JSON.parse(window.localStorage.getItem(key) || '[]')); }
        catch { return []; }
      };
      try {
        if (window.localStorage.getItem(key) === null) {
          const legacy = clean(JSON.parse(window.localStorage.getItem(legacyKey) || '[]'));
          if (legacy.length) window.localStorage.setItem(key, JSON.stringify(legacy));
        }
      } catch {}
      let items = read();
      const label = (pattern, title) => pattern.replace('[product]', title);
      const announce = (message, error = false) => {
        clearTimeout(toastTimer);
        if (dialog.open && error) {
          const errorMessage = dialog.querySelector('[data-ve-wishlist-error]');
          errorMessage.textContent = message;
          errorMessage.hidden = false;
          return;
        }
        toast.querySelector('[data-ve-wishlist-message]').textContent = message;
        toast.querySelector('[data-ve-wishlist-open]').hidden = error;
        toast.hidden = false;
        toastTimer = setTimeout(() => { toast.hidden = true; }, error ? 8000 : 5000);
      };
      const sync = () => {
        const handles = new Set(items.map(item => item.handle));
        document.querySelectorAll('[data-ve-wishlist-toggle]').forEach(button => {
          const saved = handles.has(button.dataset.handle);
          button.hidden = false;
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', label(saved ? strings.remove : strings.add, button.dataset.title || ''));
        });
        document.querySelectorAll('.ve-wishlist-header').forEach(button => {
          button.hidden = false;
          button.setAttribute('aria-label', strings.countLabel.replace('[count]', String(items.length)));
        });
        document.querySelectorAll('[data-ve-wishlist-count]').forEach(badge => {
          const count = String(items.length);
          if (badge.textContent !== count) badge.textContent = count;
          badge.hidden = !items.length;
        });
        const total = dialog.querySelector('[data-ve-wishlist-total]');
        const count = '(' + items.length + ')';
        if (total.textContent !== count) total.textContent = count;
      };
      const getProduct = handle => {
        if (!cache.has(handle)) {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 8000);
          const request = fetch(productUrl(handle) + '.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}, signal: controller.signal})
            .then(response => {
              if (response.status === 404) return null;
              if (!response.ok) throw new Error('Product request failed');
              return response.json();
            })
            .catch(error => { cache.delete(handle); throw error; })
            .finally(() => clearTimeout(timer));
          cache.set(handle, request);
        }
        return cache.get(handle);
      };
      const money = cents => {
        try { return new Intl.NumberFormat(strings.locale || 'en-GB', {style: 'currency', currency: strings.currency}).format(cents / 100); }
        catch { return (cents / 100).toFixed(2) + ' ' + strings.currency; }
      };
      const refreshRow = async (item, row, version) => {
        const price = row.querySelector('[data-wish-price]');
        const availability = row.querySelector('[data-wish-availability]');
        try {
          const product = await getProduct(item.handle);
          if (version !== generation || !dialog.open) return;
          if (!product) {
            price.hidden = true;
            availability.textContent = strings.unavailable;
            availability.hidden = false;
            row.querySelectorAll('a').forEach(link => link.removeAttribute('href'));
            row.querySelector('[data-wish-view]').hidden = true;
            return;
          }
          row.querySelector('[data-wish-title]').textContent = product.title;
          row.querySelector('[data-ve-wishlist-remove]').setAttribute('aria-label', label(strings.remove, product.title));
          const image = safeUrl(product.featured_image, true);
          if (image) {
            const imageElement = row.querySelector('[data-wish-image]');
            const resizedImage = new URL(image);
            resizedImage.searchParams.set('width', '224');
            imageElement.src = resizedImage.href;
            imageElement.hidden = false;
          }
          const cents = Number(product.price_min ?? product.price);
          price.textContent = Number.isFinite(cents) ? (product.price_varies ? strings.from + ' ' : '') + money(cents) : '';
          price.hidden = !Number.isFinite(cents);
          availability.textContent = product.available ? '' : strings.soldOut;
          availability.hidden = Boolean(product.available);
        } catch {
          if (version !== generation || !dialog.open) return;
          price.hidden = true;
          availability.textContent = strings.loadError;
          availability.hidden = false;
        }
      };
      const render = () => {
        const version = ++generation;
        body.replaceChildren();
        if (!items.length) {
          body.append(emptyTemplate.content.cloneNode(true));
          return;
        }
        const rows = items.map(item => {
          const row = itemTemplate.content.firstElementChild.cloneNode(true);
          row.dataset.handle = item.handle;
          row.querySelectorAll('a').forEach(link => { link.href = productUrl(item.handle); });
          row.querySelector('[data-wish-title]').textContent = item.title;
          const image = row.querySelector('[data-wish-image]');
          if (item.image) image.src = item.image;
          else image.hidden = true;
          row.querySelector('[data-wish-price]').textContent = strings.loading;
          const remove = row.querySelector('[data-ve-wishlist-remove]');
          remove.dataset.handle = item.handle;
          remove.setAttribute('aria-label', label(strings.remove, item.title));
          body.append(row);
          return {item, row};
        });
        let index = 0;
        const worker = async () => {
          while (index < rows.length && version === generation && dialog.open) {
            const {item, row} = rows[index++];
            await refreshRow(item, row, version);
          }
        };
        for (let i = 0; i < Math.min(4, rows.length); i++) worker();
      };
      const write = next => {
        try { window.localStorage.setItem(key, JSON.stringify(next)); }
        catch { announce(strings.storageError, true); return false; }
        items = next;
        dialog.querySelector('[data-ve-wishlist-error]').hidden = true;
        sync();
        if (dialog.open) render();
        return true;
      };
      const open = button => {
        if (dialog.open) return;
        items = read();
        sync();
        opener = button;
        toast.hidden = true;
        dialog.showModal();
        document.documentElement.classList.add('ve-wishlist-open');
        render();
      };
      document.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const toggle = event.target.closest('[data-ve-wishlist-toggle]');
        const remove = event.target.closest('[data-ve-wishlist-remove]');
        const openButton = event.target.closest('[data-ve-wishlist-open]');
        const closeButton = event.target.closest('[data-ve-wishlist-close]');
        if (toggle || remove) {
          event.preventDefault();
          event.stopPropagation();
          const button = toggle || remove;
          const handle = button.dataset.handle;
          if (!validHandle(handle)) return;
          items = read();
          const saved = items.some(item => item.handle === handle);
          const position = Array.from(body.querySelectorAll('[data-ve-wishlist-remove]')).indexOf(button);
          const next = saved ? items.filter(item => item.handle !== handle) : [...items, ...clean([{handle, title: button.dataset.title, image: button.dataset.image, url: button.dataset.url}])];
          if (write(next)) {
            if (dialog.open) {
              const buttons = body.querySelectorAll('[data-ve-wishlist-remove]');
              (buttons[Math.min(Math.max(position, 0), buttons.length - 1)] || dialog.querySelector('[data-ve-wishlist-close]')).focus();
            } else announce(saved ? strings.removed : strings.added);
          }
        } else if (openButton) {
          event.preventDefault();
          open(openButton);
        } else if (closeButton) {
          dialog.close();
        }
      }, true);
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        generation++;
        document.documentElement.classList.remove('ve-wishlist-open');
        if (opener?.isConnected) opener.focus();
      });
      window.addEventListener('storage', event => {
        if (event.key !== key && event.key !== null) return;
        items = read();
        sync();
        if (dialog.open) render();
      });
      window.addEventListener('pageshow', () => { items = read(); sync(); });
      const observer = new MutationObserver(records => {
        const selector = '[data-ve-wishlist-toggle],.ve-wishlist-header';
        if (scheduled || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; sync(); });
      });
      observer.observe(document.body, {childList: true, subtree: true});
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
